document.addEventListener('DOMContentLoaded', () => {
  initAboutIntroOverlay(initAboutHeroTypewriter);
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.about-hero__typewriter')) {
    initAboutHeroTypewriter();
  }
});

function initAboutHeroTypewriter() {
  const el = document.querySelector('.about-hero__typewriter');
  if (!el || el.dataset.initialized === 'true') return;

  const frameEl = el.querySelector('.about-hero__typewriter-frame');
  if (!frameEl) return;

  const frames = [];
  let i = 1;
  while (el.dataset[`frame-${i}`]) {
    frames.push(el.dataset[`frame-${i}`]);
    i++;
  }
  if (!frames.length) return;

  el.dataset.initialized = 'true';

  const typeSpeed    = getNumber(el.dataset.typeSpeed,    120);
  const deleteSpeed  = getNumber(el.dataset.deleteSpeed,   80);
  const displayDelay = getNumber(el.dataset.displayDelay, 1500);
  const nextDelay    = getNumber(el.dataset.nextDelay,     500);

  let frameIndex = 0;
  let isDeleting = false;
  let timerId = null;

  function update() {
    if (!document.documentElement.contains(el)) {
      clearTimeout(timerId);
      return;
    }

    if (!isDeleting) {
      frameIndex += 1;
      frameEl.src = frames[frameIndex - 1];
      frameEl.style.display = '';

      if (frameIndex >= frames.length) {
        isDeleting = true;
        timerId = setTimeout(update, displayDelay);
        return;
      }

      timerId = setTimeout(update, typeSpeed);
      return;
    }

    frameIndex -= 1;

    if (frameIndex <= 0) {
      frameEl.style.display = 'none';
      frameIndex = 0;
      isDeleting = false;
      timerId = setTimeout(update, nextDelay);
      return;
    }

    frameEl.src = frames[frameIndex - 1];
    timerId = setTimeout(update, deleteSpeed);
  }

  timerId = setTimeout(update, nextDelay);
}

function getNumber(value, fallback) {
  const number = Number.parseInt(value, 10);
  return Number.isNaN(number) ? fallback : number;
}

function initAboutIntroOverlay(onComplete) {
  const overlay = document.querySelector('.js-about-intro-overlay');
  const cursor = document.getElementById('customCursor');
  const isPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (!overlay || !isPointer) {
    if (overlay) overlay.remove();
    setTimeout(() => onComplete?.(), 500);
    return;
  }

  // 収縮中はカーソルを非表示
  if (cursor) cursor.classList.add('is-about-hidden');

  let cx = window.innerWidth / 2;
  let cy = window.innerHeight / 2;

  const onMove = (e) => { cx = e.clientX; cy = e.clientY; };
  document.addEventListener('mousemove', onMove, { passive: true });

  setTimeout(() => {
    document.removeEventListener('mousemove', onMove);

    const maxR = Math.hypot(window.innerWidth, window.innerHeight);
    const duration = 800;
    const start = performance.now();

    function easeOut(t) {
      return 1 - (1 - t) * (1 - t);
    }

    function frame(now) {
      const t = Math.min((now - start) / duration, 1);
      const radius = maxR * (1 - easeOut(t));
      overlay.style.clipPath = `circle(${radius}px at ${cx}px ${cy}px)`;

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        overlay.remove();

        // カーソルをポップアニメーションで表示
        if (cursor) {
          cursor.style.left = cx + 'px';
          cursor.style.top = cy + 'px';
          cursor.classList.remove('is-about-hidden');
          cursor.classList.add('is-about-popping');
          cursor.addEventListener('animationend', () => {
            cursor.classList.remove('is-about-popping');
            onComplete?.();
          }, { once: true });
        } else {
          onComplete?.();
        }
      }
    }

    requestAnimationFrame(frame);
  }, 1000);
}
